export default [
  {
    ru: {
      title: "ДЕЛОВАЯ РЕПУТАЦИЯ КОНТРАГЕНТА",
      content: "",
    },
    ua: {
      title: "ДІЛОВА РЕПУТАЦІЯ КОНТРАГЕНТА",
      content: "",
    },
    en: {
      title: "BUSINESS REPUTATION OF THE CONTRACTOR",
      content: "",
    },
    icon: 'reputation'
  },
  {
    ru: {
      title: "ВЫСОКОЕ КАЧЕСТВО ПРЕДЛАГАЕМЫХ МАТЕРИАЛОВ И УСЛУГ",
      content: "",
    },
    ua: {
      title: "НАЙВИЩА ЯКІСТЬ ЗАПРОПОНОВАНИХ МАТЕРІАЛІВ ТА ПОСЛУГ",
      content: "",
    },
    en: {
      title: "HIGH QUALITY OF THE OFFERED MATERIALS AND SERVICES",
      content: "",
    },
    icon: 'technical_support'
  },
  {
    ru: {
      title: "СВОЕВРЕМЕННОСТЬ ПОСТАВОК",
      content: "",
    },
    ua: {
      title: "СВОЄЧАСНІСТЬ ПОСТАВОК",
      content: "",
    },
    en: {
      title: "TIMELINESS OF DELIVERIES",
      content: "",
    },
    icon: 'calendar'

  },
  {
    ru: {
      title: "ОПТИМАЛЬНЫЙ УРОВЕНЬ ЦЕН И ПРИЕМЛЕМЫЕ УСЛОВИЯ ОПЛАТЫ",
      content: "",
    },
    ua: {
      title: "ОПТИМАЛЬНИЙ РІВЕНЬ ЦІН І ПРИЙНЯТНІ УМОВИ ОПЛАТИ",
      content: "",
    },
    en: {
      title: "OPTIMAL PRICE LEVEL AND ACCEPTABLE PAYMENT TERMS",
      content: "",
    },
    icon: 'term_loan'
  },
  {
    ru: {
      title: "ДОЛГОСРОЧНЫЕ ПАРТНЕРСКИХ ОТНОШЕНИЯ С ПОСТАВЩИКАМИ",
      content: "",
    },
    ua: {
      title: "ДОВГОСТРОКОВІ ПАРТНЕРСЬКІ ВІДНОСИНИ З ПОСТАЧАЛЬНИКАМИ",
      content: "",
    },
    en: {
      title: "LONG-TERM PARTNERSHIPS WITH SUPPLIERS",
      content: "",
    },
    icon: 'partnerships'
  },
  {
    ru: {
      title: "ПРОЗРАЧНОСТЬ И ОТКРЫТОСТЬ",
      content: "",
    },
    ua: {
      title: "ПРОЗОРІСТЬ І ВІДКРИТІСТЬ",
      content: "",
    },
    en: {
      title: "TRANSPARENCY AND OPENNESS",
      content: "",
    },
    icon: 'transparency'
  },
]

export const title = {
  ru: {
    title: "НАШИ ПРИНЦИПЫ",
    content_1: 'Для Электропромремонт качество — это приоритет. Именно поэтому мы даем возможность всем производителям и поставщикам стать нашими партнерами по открытой и прозрачной системе. Основные принципы, которыми руководствуется компания при осуществлении закупок и выборе поставщика товаров или услуг:',
    content_2: 'Наше предприятие всегда открыто для сотрудничества с партнерами, которые соответствуют перечисленным критериям.',
  },
  en: {
    title: "OUR PRINCIPLES",
    content_1: 'Quality is a priority for Elektropromremont. That is why we enable all manufacturers and suppliers to become our partners in an open and transparent system. The main principles that guide the company in the procurement and selection of a supplier of goods or services:',
    content_2: 'Our company is always open for cooperation with partners who meet the listed criteria.',
  },
  ua: {
    title: "НАШІ ПРИНЦИПИ",
    content_1: 'Для Електропромремонт якість - це пріоритет. Саме тому ми даємо можливість всім виробникам і постачальникам стати нашими партнерами по відкритій і прозорій системі. Основні принципи, якими керується компанія при здійсненні закупівель та виборі постачальника товарів або послуг:',
    content_2: 'Наше підприємство завжди відкрите для співпраці з партнерами, які відповідають перерахованим критеріям.',
  }
}

